export default "__VITE_ASSET__B87Ln_T___"